import React from 'react'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Skeleton from '@mui/material/Skeleton'
import palette from '../../../theme/palette'

/**
 * One number from the mail's "Brief Summary". `tone` colours the value: 'profit' | 'loss' | 'warning' | 'neutral'.
 * Pre-formatted `value` string so rupees keep Indian grouping and whole-percent rounding.
 * `change` = { text, tone: 'up'|'down'|'flat' } — the movement against the previous period, coloured green when it is good.
 */
export default function KpiTile({ title, value, sub, tone = 'neutral', loading, onClick, change }) {
  const color = {
    profit: palette.success.dark,
    loss: palette.error.dark,
    warning: palette.warning.dark,
    neutral: palette.text.primary,
  }[tone] || palette.text.primary

  return (
    <Paper
      variant='outlined'
      onClick={onClick}
      sx={{
        p: 2, position: 'relative', overflow: 'hidden', minWidth: 0,
        cursor: onClick ? 'pointer' : 'default',
        bgcolor: tone === 'warning' ? palette.warning.lighter : 'background.paper',
        borderColor: tone === 'warning' ? palette.warning.light : palette.grey[300],
        '&::before': { content: '""', position: 'absolute', top: 0, left: 0, width: 4, height: '100%', bgcolor: color },
      }}
    >
      <Typography variant='caption' sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: '0.68rem', display: 'block' }}>
        {title}
      </Typography>
      {loading ? (
        <Skeleton width={90} height={34} sx={{ mt: 0.5 }} />
      ) : (
        <Typography variant='h5' sx={{ mt: 0.5, fontWeight: 800, color, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
          {value}
        </Typography>
      )}
      {sub && !loading && (
        <Typography variant='caption' sx={{ color: 'text.disabled', display: 'block', mt: 0.25 }}>{sub}</Typography>
      )}
      {change && change.text && !loading && (
        <Typography variant='caption' sx={{ display: 'block', mt: 0.25, fontWeight: 600, color: change.tone === 'up' ? palette.success.dark : change.tone === 'down' ? palette.error.dark : 'text.secondary' }}>
          {change.text}
        </Typography>
      )}
    </Paper>
  )
}
